// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"styles_dataTable__AquOq","scrollableContainer":"styles_scrollableContainer__WA5sy","tableEntries":"styles_tableEntries__ENqLO"};